import tokens from '@elhub/ds-tokens/dist/tokens.json'
import { useAppSelector } from 'store'
import styled from 'styled-components'

const HLine = styled('div')`
  width: 100%;
  height: 1px;
`

export const HorizontalLine = () => {
  const { theme }: any = useAppSelector((state) => ({
    theme: state.app.theme
  }))

  return (
    <HLine
      style={{
        backgroundColor: theme === 'dark' ? tokens['eds-color-white'] : tokens['eds-color-black']
      }}
    />
  )
}
